import React from 'react';
import '../../src/bootstrap.css';


const Contact = () => {
 return (
  <>
   <h3 className="text-center text-dark my-4">You are free to Contact us</h3>
   <p className="text-center">or visit our website for more details www.daniekeys.com</p>
   {/* <HeroSection /> */}
   {/* <Cards /> */}
   {/* <Footer /> */}
  </>
 )
}

export default Contact